module.exports = __webpack_public_path__ + "img/capabilities.10022a8e.jpg";